module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('InputDefaultForm', {
    attrs: {
      "dataInputOption": _vm.dataInputOption,
      "type": 'number',
      "success": _vm.success
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.dataInputOption = $event
      },
      "keydown": _vm.keydown
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-017f791a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/forms/extended/InputNumber/InputNumberForm.vue.html
// module id = 1iHH
// module chunks = 2